// Import 1st Conclave on July Revolution images
import conclaveJulyRevolution01 from '../../assets/projects/event_branding/conclave_july_revolution/1.jpg';
import conclaveJulyRevolution02 from '../../assets/projects/event_branding/conclave_july_revolution/2.jpg';
import conclaveJulyRevolution03 from '../../assets/projects/event_branding/conclave_july_revolution/3.jpg';
import conclaveJulyRevolution04 from '../../assets/projects/event_branding/conclave_july_revolution/4.jpg';
import conclaveJulyRevolution05 from '../../assets/projects/event_branding/conclave_july_revolution/5.jpg';
import conclaveJulyRevolution06 from '../../assets/projects/event_branding/conclave_july_revolution/6.jpg';
import conclaveJulyRevolution07 from '../../assets/projects/event_branding/conclave_july_revolution/7.jpg';
import conclaveJulyRevolution08 from '../../assets/projects/event_branding/conclave_july_revolution/8.jpg';
import conclaveJulyRevolution09 from '../../assets/projects/event_branding/conclave_july_revolution/9.jpg';
import conclaveJulyRevolution10 from '../../assets/projects/event_branding/conclave_july_revolution/10.jpg';
import conclaveJulyRevolution11 from '../../assets/projects/event_branding/conclave_july_revolution/11.jpg';

// Import Bakshal 1.0 Talk Show images
import bakshalTalkShow01 from '../../assets/projects/event_branding/bakshal_talk_show/1.jpg';
import bakshalTalkShow02 from '../../assets/projects/event_branding/bakshal_talk_show/2.jpg';
import bakshalTalkShow03 from '../../assets/projects/event_branding/bakshal_talk_show/3.jpg';
import bakshalTalkShow04 from '../../assets/projects/event_branding/bakshal_talk_show/4.jpg';
import bakshalTalkShow05 from '../../assets/projects/event_branding/bakshal_talk_show/5.jpg';
import bakshalTalkShow06 from '../../assets/projects/event_branding/bakshal_talk_show/6.jpg';
import bakshalTalkShow07 from '../../assets/projects/event_branding/bakshal_talk_show/7.jpg';

// Import International Climate Camp images
import climateCamp01 from '../../assets/projects/event_branding/international_climate_camp/1.jpg';
import climateCamp02 from '../../assets/projects/event_branding/international_climate_camp/2.jpg';
import climateCamp03 from '../../assets/projects/event_branding/international_climate_camp/3.jpg';
import climateCamp04 from '../../assets/projects/event_branding/international_climate_camp/4.jpg';
import climateCamp05 from '../../assets/projects/event_branding/international_climate_camp/5.jpg';

// Import Blue Moon Grand Opening images
import blueMoon01 from '../../assets/projects/event_branding/blue_moon_outlet_opening/1.jpg';
import blueMoon02 from '../../assets/projects/event_branding/blue_moon_outlet_opening/2.jpg';
import blueMoon03 from '../../assets/projects/event_branding/blue_moon_outlet_opening/3.jpg';
import blueMoon04 from '../../assets/projects/event_branding/blue_moon_outlet_opening/4.jpg';
import blueMoon05 from '../../assets/projects/event_branding/blue_moon_outlet_opening/5.jpg';
import blueMoon06 from '../../assets/projects/event_branding/blue_moon_outlet_opening/6.jpg';

// Import Arrow Air Travels images
import arrowAir01 from '../../assets/projects/branding/arrow_air_travels/1.jpg';
import arrowAir02 from '../../assets/projects/branding/arrow_air_travels/2.jpg';
import arrowAir03 from '../../assets/projects/branding/arrow_air_travels/3.jpg';
import arrowAir04 from '../../assets/projects/branding/arrow_air_travels/4.jpg';
import arrowAir05 from '../../assets/projects/branding/arrow_air_travels/5.jpg';
import arrowAir06 from '../../assets/projects/branding/arrow_air_travels/6.jpg';

// Import Seaside Communications images
import seaside01 from '../../assets/projects/logo_design/seaside_communications/1.jpg';
import seaside02 from '../../assets/projects/logo_design/seaside_communications/2.jpg';
import seaside03 from '../../assets/projects/logo_design/seaside_communications/3.jpg';
import seaside04 from '../../assets/projects/logo_design/seaside_communications/4.jpg';
import seaside05 from '../../assets/projects/logo_design/seaside_communications/5.jpg';
import seaside06 from '../../assets/projects/logo_design/seaside_communications/6.jpg';

// Import Book & Notebook Cover Design images
import bookCover01 from '../../assets/projects/print_design/book_cover/1.jpg';
import bookCover02 from '../../assets/projects/print_design/book_cover/2.jpg';
import bookCover03 from '../../assets/projects/print_design/book_cover/3.jpg';
import bookCover04 from '../../assets/projects/print_design/book_cover/4.jpg';
import bookCover05 from '../../assets/projects/print_design/book_cover/5.jpg';
import bookCover06 from '../../assets/projects/print_design/book_cover/6.jpg';
import bookCover07 from '../../assets/projects/print_design/book_cover/7.jpg';
import bookCover08 from '../../assets/projects/print_design/book_cover/8.jpg';
import bookCover09 from '../../assets/projects/print_design/book_cover/9.jpg';
import bookCover10 from '../../assets/projects/print_design/book_cover/10.jpg';
import bookCover11 from '../../assets/projects/print_design/book_cover/11.jpg';
import bookCover12 from '../../assets/projects/print_design/book_cover/12.jpg';
import bookCover13 from '../../assets/projects/print_design/book_cover/13.jpg';
import bookCover14 from '../../assets/projects/print_design/book_cover/14.jpg';

// Import Biodiversity Summit images
import biodiversitySummit01 from '../../assets/projects/event_branding/biodiversity_summit/1.jpg';
import biodiversitySummit02 from '../../assets/projects/event_branding/biodiversity_summit/2.jpg';
import biodiversitySummit03 from '../../assets/projects/event_branding/biodiversity_summit/3.jpg';
import biodiversitySummit04 from '../../assets/projects/event_branding/biodiversity_summit/4.jpg';
import biodiversitySummit05 from '../../assets/projects/event_branding/biodiversity_summit/5.jpg';
import biodiversitySummit06 from '../../assets/projects/event_branding/biodiversity_summit/6.jpg';
import biodiversitySummit07 from '../../assets/projects/event_branding/biodiversity_summit/7.jpg';
import biodiversitySummit08 from '../../assets/projects/event_branding/biodiversity_summit/8.jpg';

// Import Al Aqsa Mega Mall Branding images
import alAqsaBranding01 from '../../assets/projects/branding/al_aqsa_mega_mall/1.jpg';
import alAqsaBranding02 from '../../assets/projects/branding/al_aqsa_mega_mall/2.jpg';
import alAqsaBranding03 from '../../assets/projects/branding/al_aqsa_mega_mall/3.jpg';
import alAqsaBranding04 from '../../assets/projects/branding/al_aqsa_mega_mall/4.jpg';
import alAqsaBranding05 from '../../assets/projects/branding/al_aqsa_mega_mall/5.jpg';
import alAqsaBranding06 from '../../assets/projects/branding/al_aqsa_mega_mall/6.jpg';
import alAqsaBranding07 from '../../assets/projects/branding/al_aqsa_mega_mall/7.jpg';

// Import Al Aqsa Mega Mall Campaign images
import alAqsaCampaign01 from '../../assets/projects/campaign/al_aqsa_mega_mall/1.jpg';
import alAqsaCampaign02 from '../../assets/projects/campaign/al_aqsa_mega_mall/2.jpg';
import alAqsaCampaign03 from '../../assets/projects/campaign/al_aqsa_mega_mall/3.jpg';

// Import Skyview Architecture and Interior images
import skyview01 from '../../assets/projects/branding/skyview/1.jpg';
import skyview02 from '../../assets/projects/branding/skyview/2.jpg';
import skyview03 from '../../assets/projects/branding/skyview/3.jpg';
import skyview05 from '../../assets/projects/branding/skyview/5.jpg';
import skyview06 from '../../assets/projects/branding/skyview/6.jpg';
import skyview07 from '../../assets/projects/branding/skyview/7.jpg';

// Import LA MESA branding images
import laMesa02 from '../../assets/projects/branding/lamesa/2.jpg';
import laMesa03 from '../../assets/projects/branding/lamesa/3.jpg';
import laMesa04 from '../../assets/projects/branding/lamesa/4.jpg';
import laMesa05 from '../../assets/projects/branding/lamesa/5.jpg';
import laMesa06 from '../../assets/projects/branding/lamesa/6.jpg';
import laMesa07 from '../../assets/projects/branding/lamesa/7.jpg';
import laMesa08 from '../../assets/projects/branding/lamesa/8.jpg';
import laMesa09 from '../../assets/projects/branding/lamesa/9.jpg';
import laMesa11 from '../../assets/projects/branding/lamesa/11.jpg';
import laMesaLogoMockup01 from '../../assets/projects/branding/lamesa/Logo_Mockup_1.jpg';

// Import Magic Initiative branding images
import magicInitiative01 from '../../assets/projects/branding/magic_initiative/1.jpg';
import magicInitiative02 from '../../assets/projects/branding/magic_initiative/2.jpg';
import magicInitiative03 from '../../assets/projects/branding/magic_initiative/3.jpg';
import magicInitiative04 from '../../assets/projects/branding/magic_initiative/4.jpg';
import magicInitiative05 from '../../assets/projects/branding/magic_initiative/5.jpg';
import magicInitiative06 from '../../assets/projects/branding/magic_initiative/6.jpg';
import magicInitiative07 from '../../assets/projects/branding/magic_initiative/7.jpg';

// Import The Three Farmers BD branding images
import threeFarmersBdPost1 from "../../assets/projects/branding/the_three_farmers's_bd/Post1.jpg";
import threeFarmersBdPost2 from "../../assets/projects/branding/the_three_farmers's_bd/Post2.jpg";
import threeFarmersBdPost3 from "../../assets/projects/branding/the_three_farmers's_bd/Post3.jpg";
import threeFarmersBdPost4 from "../../assets/projects/branding/the_three_farmers's_bd/Post4.jpg";
import threeFarmersBdPost5 from "../../assets/projects/branding/the_three_farmers's_bd/Post5.jpg";
import threeFarmersBdPost6 from "../../assets/projects/branding/the_three_farmers's_bd/Post6.jpg";

// ============================================================================
// SINGLE SOURCE OF TRUTH - All project data (following DRY principle)
// ============================================================================
export const projectsData = [
    {
        id: 1,
        title: "1st Conclave on July Revolution",
        slug: "1st-conclave-on-july-revolution",
        category: "Event Branding",
        client: "1st Conclave on July Revolution",
        date: "September 2026",
        featured: true, // Featured on homepage (keep first)
        image: conclaveJulyRevolution02,
        gallery: [
            conclaveJulyRevolution01,
            conclaveJulyRevolution02,
            conclaveJulyRevolution03,
            conclaveJulyRevolution04,
            conclaveJulyRevolution05,
            conclaveJulyRevolution06,
            conclaveJulyRevolution07,
            conclaveJulyRevolution08,
            conclaveJulyRevolution09,
            conclaveJulyRevolution10,
            conclaveJulyRevolution11,
        ],
        description:
            "A complete visual communication and event branding project for the 1st Conclave on July Revolution, with a consistent visual identity across digital and physical materials: social media creatives, event banners, stage backdrop, event bags, diaries, bookmarks, ID cards, T-shirts, and promotional and event collaterals.",
        challenge:
            "The event needed one recognisable identity that would hold together across a large number of formats, from social media posts to the stage backdrop and printed attendee kits.",
        solution:
            "A unified event identity was applied to every touchpoint, covering social media design, event banners, stage backdrop, bags, diaries, bookmarks, ID cards, T-shirts, and other print collaterals.",
        results:
            "Deliverables: event branding, social media design, and print collaterals, delivered as one consistent visual system for the conclave.",
    },
    {
        id: 2,
        title: "Bangladesh Biodiversity Summit 2025",
        slug: "bangladesh-biodiversity-summit-2025",
        category: "Event Branding",
        client: "Bangladesh Biodiversity Summit",
        date: "November 2025",
        featured: true, // Featured on homepage
        image: biodiversitySummit01,
        gallery: [
            biodiversitySummit01,
            biodiversitySummit02,
            biodiversitySummit03,
            biodiversitySummit04,
            biodiversitySummit05,
            biodiversitySummit06,
            biodiversitySummit07,
            biodiversitySummit08,
        ],
        description:
            "Arvix Creative proudly partnered with the Bangladesh Biodiversity Summit 2025, delivering comprehensive creative, printing, and logistical support for this nationally significant event. Our scope of work included end-to-end creative solutions including event branding, visual identity, stage and venue graphics, and all promotional materials, ensuring a cohesive and impactful presence throughout the summit.",
        challenge:
            "The Bangladesh Biodiversity Summit 2025 required a comprehensive creative solution that would effectively communicate the importance of biodiversity conservation on a national scale. The challenge was to create a cohesive visual identity that would work across multiple touchpoints, from digital promotions to large-scale venue graphics, while maintaining the gravitas appropriate for such a significant national event.",
        solution:
            "We developed a complete event branding system that included a distinctive visual identity, comprehensive stage and venue graphics, and all promotional materials. Our approach ensured visual consistency across all applications, from digital marketing materials to physical venue installations, creating a unified and impactful brand presence that elevated the summit's message and importance.",
        results:
            "The event branding successfully created a cohesive and professional presence throughout the summit, with all materials working together to reinforce the event's significance. The comprehensive design solution received positive feedback from organizers and attendees, contributing to the overall success of the nationally significant event.",
    },
    {
        id: 3,
        title: "Al Aqsa Mega Mall",
        slug: "al-aqsa-mega-mall",
        category: "Branding",
        client: "Al Aqsa Mega Mall",
        date: "October 2025",
        featured: true, // Featured on homepage
        image: alAqsaBranding01,
        gallery: [
            alAqsaBranding01,
            alAqsaBranding02,
            alAqsaBranding03,
            alAqsaBranding04,
            alAqsaBranding05,
            alAqsaBranding06,
            alAqsaBranding07,
        ],
        description:
            "Complete brand identity design for Al Aqsa Mega Mall, including logo design, visual identity system, and comprehensive branding materials that reflect the modern retail experience and commercial excellence.",
        challenge:
            "The client needed a brand identity that would establish Al Aqsa Mega Mall as a premier shopping destination. The challenge was to create a brand that communicates modernity, trustworthiness, and commercial appeal while standing out in a competitive retail market.",
        solution:
            "We developed a distinctive visual identity that combines contemporary design elements with professional typography and a sophisticated color palette. The logo and brand system were designed to work across various applications, from exterior signage and wayfinding to marketing materials and digital platforms, creating a cohesive brand experience that communicates quality and professionalism.",
        results:
            "The brand identity has been successfully implemented across all touchpoints, helping Al Aqsa Mega Mall establish a strong market presence. The cohesive design system has contributed to brand recognition and customer trust, with the visual identity effectively communicating the mall's commitment to providing an excellent shopping experience.",
    },
    {
        id: 4,
        title: "Skyview Architecture and Interior",
        slug: "skyview-architecture-and-interior",
        category: "Branding",
        client: "Skyview Architecture and Interior",
        date: "November 2025",
        featured: true, // Featured on homepage
        image: skyview01,
        gallery: [
            skyview01,
            skyview02,
            skyview03,
            skyview05,
            skyview06,
            skyview07,
        ],
        description:
            "Thrilled to have worked with an incredible architecture and interior design firm to develop their brand identity! From designing the logo, visiting cards, and stationery, every element was crafted to reflect their vision and values. It's always fulfilling to help brands build a cohesive identity that resonates with their audience.",
        challenge:
            "Skyview Architecture and Interior needed a comprehensive brand identity that would reflect their expertise in architecture and interior design while establishing a professional and trustworthy presence in a competitive market. The challenge was to create a cohesive visual system that would work across multiple applications and effectively communicate their creative philosophy.",
        solution:
            "We developed a complete brand identity system including logo design, visiting cards, and stationery. Every element was thoughtfully crafted to reflect the firm's vision and values, creating a cohesive identity that resonates with their target audience. The design balances professionalism with creativity, perfectly suited for an architecture and interior design practice.",
        results:
            "The brand identity has been successfully implemented across all materials, helping Skyview Architecture and Interior establish a strong and recognizable presence. The cohesive design system has contributed to brand recognition and has been well-received by both the client and their audience, effectively communicating the firm's expertise and professionalism.",
    },
    {
        id: 5,
        title: "The Three Farmer's BD",
        slug: "the-three-farmers-bd",
        category: "Branding",
        client: "The Three Farmer's BD",
        date: "April 2026",
        featured: false,
        image: threeFarmersBdPost1,
        gallery: [
            threeFarmersBdPost1,
            threeFarmersBdPost2,
            threeFarmersBdPost3,
            threeFarmersBdPost4,
            threeFarmersBdPost5,
            threeFarmersBdPost6,
        ],
        description:
            "The Three Farmer's BD is an organic food brand representing unity, sustainability, and trust. The identity communicates natural purity, responsible cultivation, and farmer empowerment through a strong and memorable visual language.",
        challenge:
            "The challenge was to create a brand that clearly expresses organic authenticity and teamwork while positioning the company as reliable and quality-driven in a competitive food market.",
        solution:
            "The logo concept features three united farmers under a rising sun, framed by farmland and protective leaf forms. Deep green communicates freshness and trust, while warm golden yellow conveys harvest and prosperity. Supporting iconography (sun, three farmers, farms, and organic cues) extends the narrative across marketing assets.",
        results:
            "The resulting identity system gives the brand a cohesive, purpose-driven presence that highlights sustainability and community values. It supports consistent communication across packaging, promotional materials, and digital touchpoints.",
    },
    {
        id: 6,
        title: "Magic Initiative",
        slug: "magic-initiative",
        category: "Logo Design",
        client: "Magic Initiative",
        date: "April 2026",
        featured: false,
        image: magicInitiative01,
        gallery: [
            magicInitiative01,
            magicInitiative02,
            magicInitiative03,
            magicInitiative04,
            magicInitiative05,
            magicInitiative06,
            magicInitiative07,
        ],
        description:
            "The Magic Initiative logo represents hope, care, and positive transformation for an NGO focused on education, climate action, health, peace, and empowerment. The identity is built to communicate trust, compassion, and sustainable social impact.",
        challenge:
            "The organization needed a symbol that could unite multiple humanitarian goals under one clear visual identity. The challenge was to balance emotional warmth with institutional credibility while reflecting community support and environmental responsibility.",
        solution:
            "We developed a mark built from open hands (support and protection), an integrated leaf (growth and climate action), and a star (hope, education, and inspiration). Maroon was selected to express dignity, compassion, and responsibility, while clean typography ensures accessibility and transparency across communication channels.",
        results:
            "The final brand system gives Magic Initiative a recognizable and mission-aligned identity that supports storytelling across outreach, awareness campaigns, and organizational materials. It strengthens trust and helps communicate long-term impact clearly.",
    },
    {
        id: 7,
        title: "LA MESA",
        slug: "la-mesa",
        category: "Branding",
        client: "LA MESA",
        date: "April 2026",
        featured: false,
        image: laMesaLogoMockup01,
        gallery: [
            laMesaLogoMockup01,
            laMesa11,
            laMesa02,
            laMesa03,
            laMesa04,
            laMesa05,
            laMesa06,
            laMesa07,
            laMesa08,
            laMesa09,
        ],
        description:
            "LA MESA (\"The Table\") represents gathering, sharing, and connection through modern dining. The identity combines a fork, flame, drop, and circular plate-inspired form to express hospitality, culinary passion, flavor, and unity in one elegant visual system.",
        challenge:
            "The challenge was to craft a premium restaurant identity that feels modern and sophisticated while still communicating warmth, togetherness, and food craftsmanship. The mark needed to stay memorable and versatile across digital and physical applications.",
        solution:
            "We designed a minimal symbol system where each form carries meaning: fork for hospitality, flame for cooking passion, drop for creativity in taste, and curved circular structure for table unity and balance. A bold sans-serif typeface paired with a gold-beige and white-on-black palette reinforces luxury, clarity, and confidence.",
        results:
            "The final brand communicates modern elegance with strong recall value, helping LA MESA present a cohesive visual experience across touchpoints. The system is scalable for menus, signage, social media, and branded collateral while maintaining premium positioning.",
    },
    {
        id: 8,
        title: "Book & Notebook Cover Design",
        slug: "book-and-notebook-cover-design",
        category: "Print Design",
        client: "Book & Notebook Covers",
        date: "December 2025",
        featured: false,
        image: bookCover01,
        gallery: [
            bookCover01,
            bookCover02,
            bookCover03,
            bookCover04,
            bookCover05,
            bookCover06,
            bookCover07,
            bookCover08,
            bookCover09,
            bookCover10,
            bookCover11,
            bookCover12,
            bookCover13,
            bookCover14,
        ],
        description:
            "A collection of book and notebook cover designs, each with its own illustration, colour palette, and typography.",
        challenge:
            "Each cover needed its own distinct identity while staying clean and print-ready.",
        solution:
            "A series of cover designs was developed with different visual themes and presented as realistic print mockups.",
        results:
            "A range of print-ready book and notebook covers.",
    },
    {
        id: 9,
        title: "Bakshal 1.0 Talk Show",
        slug: "bakshal-talk-show",
        category: "Event Branding",
        client: "Bangladesh Narrative",
        date: "December 2025",
        featured: false,
        image: bakshalTalkShow01,
        gallery: [
            bakshalTalkShow01,
            bakshalTalkShow02,
            bakshalTalkShow03,
            bakshalTalkShow04,
            bakshalTalkShow05,
            bakshalTalkShow06,
            bakshalTalkShow07,
        ],
        description:
            "Complete visual branding for Bakshal 1.0, a talk show exploring political insights, national issues, and contemporary perspectives on Bangladesh's governance and social landscape, designed for Bangladesh Narrative.",
        challenge:
            "The talk show needed a bold, consistent look for its speaker announcements and promotional posters.",
        solution:
            "A strong poster system was designed with a fixed layout, typography, and colour treatment, applied to each speaker announcement and a combined line-up poster.",
        results:
            "A recognisable series of promotional creatives for the show.",
    },
    {
        id: 10,
        title: "Seaside Communications",
        slug: "seaside-communications",
        category: "Logo Design",
        client: "Seaside Communications",
        date: "October 2025",
        featured: false,
        image: seaside06,
        gallery: [
            seaside01,
            seaside02,
            seaside03,
            seaside04,
            seaside05,
            seaside06,
        ],
        description:
            "Logo design and brand identity for Seaside Communications, shown across business cards, stationery, apparel, caps, and mobile applications.",
        challenge:
            "The company needed a simple, memorable mark that works well at both small and large sizes.",
        solution:
            "A logo and logotype were created and tested across business cards, stationery, T-shirts, caps, and digital screens.",
        results:
            "A versatile logo and visual identity for the brand's everyday applications.",
    },
    {
        id: 11,
        title: "Al Aqsa Mega Mall Campaign",
        slug: "al-aqsa-mega-mall-campaign",
        category: "Campaign",
        client: "Al Aqsa Mega Mall",
        date: "October 2025",
        featured: false,
        image: alAqsaCampaign01,
        gallery: [
            alAqsaCampaign01,
            alAqsaCampaign02,
            alAqsaCampaign03,
        ],
        description:
            "Strategic marketing campaign design for Al Aqsa Mega Mall, featuring engaging promotional materials, social media graphics, and advertising creatives designed to drive foot traffic and enhance brand visibility in the competitive retail market.",
        challenge:
            "The client needed a comprehensive marketing campaign that would effectively promote Al Aqsa Mega Mall and attract customers. The challenge was to create campaign materials that would stand out in a crowded marketplace while maintaining consistency with the established brand identity and communicating the mall's unique value proposition.",
        solution:
            "We developed a cohesive campaign strategy with visually striking promotional materials that leverage the brand's visual identity while adding dynamic campaign-specific elements. The campaign materials were designed to work across multiple channels including print advertising, social media, and digital platforms, ensuring consistent messaging and maximum reach.",
        results:
            "The campaign successfully increased brand awareness and customer engagement, with the promotional materials effectively communicating Al Aqsa Mega Mall's offerings and attracting new visitors. The cohesive campaign design maintained brand consistency while creating excitement and driving measurable results in customer acquisition and brand recognition.",
    },
    {
        id: 12,
        title: "International Climate Camp",
        slug: "international-climate-camp",
        category: "Event Branding",
        client: "International Climate Camp",
        date: "July 2025",
        featured: false,
        image: climateCamp01,
        gallery: [
            climateCamp01,
            climateCamp02,
            climateCamp03,
            climateCamp04,
            climateCamp05,
        ],
        description:
            "Event branding for the International Climate Camp, including T-shirts, lanyards and ID cards, certificates, and promotional social media creatives.",
        challenge:
            "The event needed a fresh, nature-led identity that could carry across apparel, credentials, certificates, and promotion.",
        solution:
            "A green, nature-inspired graphic system was developed and applied to T-shirts, ID cards and lanyards, certificates, and promotional creatives.",
        results:
            "A cohesive set of event materials sharing one visual language.",
    },
    {
        id: 13,
        title: "Arrow Air Travels",
        slug: "arrow-air-travels",
        category: "Branding",
        client: "Arrow Air Travels",
        date: "July 2024",
        featured: false,
        image: arrowAir01,
        gallery: [
            arrowAir01,
            arrowAir02,
            arrowAir03,
            arrowAir04,
            arrowAir05,
            arrowAir06,
        ],
        description:
            "Brand identity design for Arrow Air Travels, including logo, business cards, invoice and stationery, and office branding applications.",
        challenge:
            "The travel agency needed a clear identity that could be applied across its everyday business materials.",
        solution:
            "A logo and visual identity were developed and applied to business cards, invoices, stationery, signage, and office applications.",
        results:
            "A consistent identity system ready for use across the agency's printed and in-office materials.",
    },
    {
        id: 14,
        title: "Blue Moon Grand Opening",
        slug: "blue-moon-grand-opening",
        category: "Event Branding",
        client: "Blue Moon",
        date: "January 2024",
        featured: false,
        image: blueMoon01,
        gallery: [
            blueMoon01,
            blueMoon02,
            blueMoon03,
            blueMoon04,
            blueMoon05,
            blueMoon06,
        ],
        description:
            "Complete event branding for the opening of Blue Moon's new outlet in January 2024, including backdrops, pole banners, roll-up banners, and ribbon.",
        challenge:
            "The new outlet opening needed coordinated grand-opening materials that matched the brand.",
        solution:
            "A grand-opening design system was created and applied to the backdrop, pole banners, roll-up banners, and opening ribbon.",
        results:
            "Consistent, on-brand event materials for the outlet opening.",
    },
];

// ============================================================================
// DERIVED DATA - Generated from projectsData (following DRY principle)
// ============================================================================

// Helper function to create lightweight project objects for lists
const createProjectSummary = (project) => ({
    id: project.id,
    title: project.title,
    slug: project.slug,
    category: project.category,
    image: project.image,
    description: project.description,
    link: `/projects/${project.slug}`,
});

// Featured projects for homepage (derived from projectsData)
export const featuredProjects = projectsData
    .filter(project => project.featured)
    .map(createProjectSummary);

// All projects for the projects page (derived from projectsData)
export const allProjects = projectsData.map(createProjectSummary);

// Project categories for filtering
export const projectCategories = [
    "All",
    ...Array.from(new Set(projectsData.map((project) => project.category))),
];
